var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading"},[_c('van-loading',{staticClass:"loading-con",attrs:{"color":"#2dd580","size":"100px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }